// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `page-full-screen-contacts-component ion-content {
  position: relative;
  --background: #fff !important;
}
page-full-screen-contacts-component .full-screen-contacts__skeleton {
  padding: 4px 0 12px;
}
page-full-screen-contacts-component .full-screen-contacts__skeleton--overlay {
  background: #fff;
  box-sizing: border-box;
  inset: 0;
  overflow: auto;
  padding: 4px 0 12px;
  position: absolute;
  z-index: 2;
}
page-full-screen-contacts-component ion-list {
  background: var(--cms-app-background-color) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/contacts-pages/full-screen-contacts-component/full-screen-contacts-component.scss"],"names":[],"mappings":"AACE;EACE,kBAAA;EACA,6BAAA;AAAJ;AAGE;EACE,mBAAA;AADJ;AAGI;EACE,gBAAA;EACA,sBAAA;EACA,QAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;AADN;AAKE;EACE,sDAAA;AAHJ","sourcesContent":["page-full-screen-contacts-component {\n  ion-content {\n    position: relative;\n    --background: #fff !important;\n  }\n\n  .full-screen-contacts__skeleton {\n    padding: 4px 0 12px;\n\n    &--overlay {\n      background: #fff;\n      box-sizing: border-box;\n      inset: 0;\n      overflow: auto;\n      padding: 4px 0 12px;\n      position: absolute;\n      z-index: 2;\n    }\n  }\n\n  ion-list {\n    background: var(--cms-app-background-color) !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
